import styled from "styled-components";
import { Flex, Icon, Type } from "discover.medical.react-component-library";
import Plan from "../Plan";

export const Container = styled.div`
  position: relative;
  &:after {
    content: "";
    display: block;
    background: ${({ theme }) => theme.colors.senary.base};
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: -1;
  }
`;

export const Tile = styled(Plan)``;

export const Tiles = styled(Flex)`
  gap: 1rem;
  justify-content: flex-start;

  @media screen and (min-width: 700px) {
    ${Tile} {
      width: 22rem;
    }
  }
`;

export const Title = styled(Type)`
  font-size: 1.5rem;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 2rem;
  }
`;

export const Logo = styled.img`
  width: 33.333%;
  max-width: 8rem;
  margin-bottom: ${({ theme }) => theme.space.sm};
  flex: none;

  @media screen and (min-width: 480px) {
    margin-right: ${({ theme }) => theme.space.md};
  }
`;

export const Intro = styled(Flex)`
  flex-direction: column;

  @media screen and (min-width: 480px) {
    align-items: flex-start;
    flex-direction: row;
  }
`;

export const IntroContent = styled.div``;

export const Bullets = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
  list-style: none;
`;

export const Bullet = styled.li`
  display: flex;
  align-items: flex-start;
  column-gap: 0.5rem;
`;

export const BulletIcon = styled(Icon)`
  fill: #99c2cc;
`;
